// @needs-native-review — best-effort translation
import type { Translations } from '../types';

export const ar: Translations = {
  'meta.gameTitle': 'Luminary',

  'howto.title': 'كيفية اللعب',
  'howto.pieces.heading': 'القطع',
  'howto.pieces.source': 'المصدر',
  'howto.pieces.mirror': 'مرآة',
  'howto.pieces.switch': 'مفتاح',
  'howto.pieces.exit': 'المخرج',
  'howto.pieces.wall': 'جدار',
  'howto.controls.heading': 'التحكم',
  'howto.controls.clickSlot.line1': 'انقر على الخانة',
  'howto.controls.clickSlot.line2': 'ضع المرآة',
  'howto.controls.dragMirror.line1': 'اسحب المرآة',
  'howto.controls.dragMirror.line2': 'استدارة',
  'howto.controls.rightClick.line1': 'النقر بالزر الأيمن',
  'howto.controls.rightClick.line2': 'إزالة المرآة',
  'howto.controls.hint':
    'عجلة الفأرة: استدارة دقيقة بمقدار 1°.   اضغط على المرآة: استدارة بمقدار 15°.',
  'howto.objective.line1': 'أضِئ كل مفتاح — يُفتح قفل المخرج.',
  'howto.objective.line2': 'ثم انقر على المخرج. حلّ بأقل عدد ممكن من المرايا.',

  'howtoColor.title': 'الألوان والمواشير',
  'howtoColor.pieces.heading': 'قطع جديدة',
  'howtoColor.pieces.prism': 'موشور',
  'howtoColor.pieces.redSwitch': 'مفتاح أحمر',
  'howtoColor.pieces.yellowSwitch': 'مفتاح أصفر',
  'howtoColor.pieces.whiteSwitch': 'مفتاح أبيض',
  'howtoColor.how.heading': 'كيف تعمل',
  'howtoColor.how.line1': 'يحمل الشعاع الأبيض الضوء الأحمر والأخضر والأزرق معاً.',
  'howtoColor.how.line2': 'يقسم الموشور الضوء الأبيض إلى ثلاثة أشعة ملونة على أضلاعه الثلاثة.',
  'howtoColor.how.line3': 'انقر على موشور موضوع لتدوير وجه الإدخال.',
  'howtoColor.switches.line1': 'تُظهر المفاتيح نقاطاً ملونة — هذا هو اللون المطلوب.',
  'howtoColor.switches.line2': 'يحتاج المفتاح الأصفر (نقطتا أحمر + أخضر) إلى كلا اللونين معاً.',
  'howtoColor.switches.line3':
    'يحتاج المفتاح الأبيض (الألوان الثلاثة) إلى الأحمر والأخضر والأزرق معاً.',

  'options.hints.label': 'إظهار زوايا التلميحات في الألغاز',
  'options.hints.help': 'يعرض الزاوية بين الشعاع الوارد والشعاع المنعكس عند كل ارتداد.',

  'level.01-intro.title': 'مرحباً، أيها الضوء',
  'level.02-two-mirrors.title': 'دورتان',
  'level.03-corner.title': 'جدار في الطريق',
  'level.04-two-targets.title': 'هدفان',
  'level.05-tight.title': 'ضيّق',
  'level.06-hello-color.title': 'مرحباً، أيها اللون',
  'level.07-pick-a-side.title': 'اختر جانباً',
  'level.08-yellow.title': 'أصفر',
  'level.09-magenta.title': 'أرجواني',
  'level.10-spectrum.title': 'طيف',

  // PuzzleScene
  'puzzle.itemCounter': '{used}/{optimal}',
  'puzzle.hint.angleType.right': 'قائمة',
  'puzzle.hint.angleType.acute': 'حادة',
  'puzzle.hint.angleType.obtuse': 'منفرجة',
  'puzzle.hint.label': '{angle}°\n{type}',
};
